import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import UserGroupApi from '../server/UserGroupApi';

function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.USER_GROUP_LIST);
        const handleError = createErrorHandler(ActionTypes.USER_GROUP_LIST_ERROR);

        return UserGroupApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.USER_GROUP_INFO);
        const handleError = createErrorHandler(ActionTypes.USER_GROUP_INFO_ERROR);

        return UserGroupApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getMembers: (id, params, clearAll = true) => {
        const types = {
            request: ActionTypes.USER_GROUP_MEMBERS_LIST_REQUEST,
            success: ActionTypes.USER_GROUP_MEMBERS_LIST_SUCCESS,
            failure: ActionTypes.USER_GROUP_MEMBERS_LIST_FAILURE
        };

        CentricDispatcher.dispatchAsync(UserGroupApi.getMembers(id, params), types, {id, params, clearAll});
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.USER_GROUP_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.USER_GROUP_INFO_ERROR);
        
        return UserGroupApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(_handleException);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.USER_GROUP_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.USER_GROUP_UPDATE_ERROR);
        
        return UserGroupApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(_handleException);
    },
    
    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.USER_GROUP_DELETE);
        const handleError = createErrorHandler(ActionTypes.USER_GROUP_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);
        
        return UserGroupApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },
  
    search: function(searchText) {
        const handleSuccess = createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED);
        const handleError = createErrorHandler(ActionTypes.SEARCH_ERROR);
        
        return UserGroupApi.search(searchText)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },
};
